import { createContext } from "react";

export interface SOrdnerOverviewContextValue {
  open: (sordnerId: number) => void;
  close: () => void;
  isOpen: boolean;
  activeId: number | null;
}

export const SOrdnerOverviewContext = createContext<SOrdnerOverviewContextValue | null>(null);
